/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Page_TextInputs */



/**
* | output |
* | --- |
* | "Nothing you saved is lost, and your publications go out anyway. Loading the page again is most often enough." |
*
* @param {Error_Page_TextInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const error_page_text = /** @type {((inputs?: Error_Page_TextInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Page_TextInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Nothing you saved is lost, and your publications go out anyway. Loading the page again is most often enough.")
	return /** @type {LocalizedString} */ ("Rien de ce que vous avez enregistré n'est perdu, et vos publications partent quand même. Recharger la page suffit le plus souvent.")
});